import React, { ReactElement } from 'react';

import classNames from 'classnames';

import { NAV_BAR_CLASS } from '../../utils/constants';
import * as Styled from './NavBar.styles';
import { INavBarProps } from './NavBar.types';

const NavBar = ({
  className = '',
  orientation = 'horizontal',
  float = false,
  children,
  leftArea,
  rightArea,
  ...rest
}: INavBarProps): ReactElement => (
  <Styled.NavBar className={classNames(NAV_BAR_CLASS, className)} orientation={orientation} float={float} {...rest}>
    {leftArea && (
      <Styled.Area number={1} orientation={orientation}>
        {leftArea}
      </Styled.Area>
    )}
    <Styled.MiddleArea>{children}</Styled.MiddleArea>
    {rightArea && (
      <Styled.Area number={3} orientation={orientation}>
        {rightArea}
      </Styled.Area>
    )}
  </Styled.NavBar>
);

export default NavBar;
